/**
 * VergleichGewichteDialog — edit the seven Ü7 weights for a run or a re-score (P2 Placement Slice 11,
 * Tab 4b). Live sum display, «Mandanten-Standard uebernehmen», «Anwenden» gated on a valid sum.
 */

import { useState } from 'react';
import {
  gewichteSumme,
  OFFER_SCORE_DIMENSION_LABELS,
  OFFER_SCORE_DIMENSION_VALUES,
  sindGewichteGueltig,
  VERGLEICH_GEWICHTE_SUMME_HINWEIS,
  type OfferScoreGewichte,
} from '@brokly/shared';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';

export function VergleichGewichteDialog({
  open,
  onClose,
  gewichte,
  tenantGewichte,
  onApply,
  saving,
}: {
  open: boolean;
  onClose: () => void;
  gewichte: OfferScoreGewichte;
  tenantGewichte: OfferScoreGewichte;
  onApply: (g: OfferScoreGewichte) => void;
  saving: boolean;
}) {
  const [draft, setDraft] = useState<OfferScoreGewichte>(gewichte);
  const summe = gewichteSumme(draft);
  const gueltig = sindGewichteGueltig(draft);

  const set = (dim: keyof OfferScoreGewichte, v: string): void => {
    const n = v === '' ? 0 : Number(v);
    setDraft((d) => ({ ...d, [dim]: Number.isFinite(n) ? Math.trunc(n) : 0 }));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Gewichtung anpassen"
      footer={
        <div className="flex justify-between gap-2">
          <Button variant="ghost" onClick={() => setDraft(tenantGewichte)}>Mandanten-Standard uebernehmen</Button>
          <div className="flex gap-2">
            <Button variant="ghost" onClick={onClose}>Abbrechen</Button>
            <Button disabled={!gueltig || saving} onClick={() => onApply(draft)} data-testid="vergleich-gewichte-anwenden">Anwenden</Button>
          </div>
        </div>
      }
    >
      <div className="flex flex-col gap-2" data-testid="vergleich-gewichte-dialog">
        {OFFER_SCORE_DIMENSION_VALUES.map((dim) => (
          <label key={dim} className="flex items-center justify-between gap-2 text-sm">
            <span>{OFFER_SCORE_DIMENSION_LABELS[dim]}</span>
            <input
              type="number"
              min={0}
              max={100}
              className="w-20 rounded-md border border-border p-1 text-right"
              value={draft[dim]}
              onChange={(e) => set(dim, e.target.value)}
              aria-label={OFFER_SCORE_DIMENSION_LABELS[dim]}
            />
          </label>
        ))}
        <div className={`mt-1 text-sm font-medium ${summe === 100 ? 'text-muted-foreground' : 'text-[var(--status-danger-text,#b42318)]'}`} data-testid="vergleich-gewichte-summe">
          Summe: {summe} %
        </div>
        {!gueltig && <p className="text-xs text-muted-foreground">{VERGLEICH_GEWICHTE_SUMME_HINWEIS}</p>}
      </div>
    </Dialog>
  );
}
